import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import {
  UserNotification,
  UserNotificationsCategories,
  UserNotificationStatus,
} from 'dashboard/models/user-notification';
import {
  addUserNotifications,
  saveUserNotifications,
} from 'dashboard/redux/slices/user-notifications';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadUserNotificationsList({
  currentPage = 1,
  pageSize = DEFAULT_PAGE_SIZE,
  categories = [],
  status = UserNotificationStatus.Delivered,
  requestKey = undefined,
}: {
  currentPage?: number;
  pageSize?: number;
  categories?: UserNotificationsCategories[];
  status?: UserNotificationStatus;
  requestKey?: string;
}) {
  return async (dispatch: Dispatch) => {
    const options = {
      filter: {
        categories,
        status,
      },
      page: {
        number: currentPage,
        size: pageSize,
      },
    };
    const { data: userNotifications, meta: paginationParams } =
      await SessionClientDashboard.listResource<UserNotification, PaginationParams>(
        ApiEndpoint.UserNotification,
        options,
      );

    const requestKeyValue = requestKey ? requestKey : JSON.stringify(options);

    dispatch(
      saveUserNotifications({
        userNotifications,
        requestKey: requestKeyValue,
        paginationParams,
      }),
    );
  };
}

export function loadUserNotificationsListAdd({
  currentPage = 1,
  pageSize = DEFAULT_PAGE_SIZE,
  categories = [],
  status = UserNotificationStatus.Delivered,
  requestKey = undefined,
}: {
  currentPage?: number;
  pageSize?: number;
  categories?: UserNotificationsCategories[];
  status?: UserNotificationStatus;
  requestKey?: string;
}) {
  return async (dispatch: Dispatch) => {
    const options = {
      filter: {
        categories,
        status,
      },
      page: {
        number: currentPage,
        size: pageSize,
      },
    };
    const { data: userNotifications, meta: paginationParams } =
      await SessionClientDashboard.listResource<UserNotification, PaginationParams>(
        ApiEndpoint.UserNotification,
        options,
      );

    const requestKeyValue = requestKey ? requestKey : JSON.stringify(options);

    dispatch(
      addUserNotifications({
        userNotifications,
        requestKey: requestKeyValue,
        paginationParams,
      }),
    );
  };
}
